







































































































































































































































































































































































































































import { PopRoute, AddRoute, ReplaceRoute, ChangePanelTitle, Ticket, User, SnackIt, setBookingId, setTicketId } from '../../types/store';
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {Mutation, State, Action, Getter} from "vuex-class";
import AdminPageInfo from './AdminPageInfo.vue';
import AdminCard from './AdminCard.vue';
import btn from './btn.vue';
import PackageCard from './PackageCard.vue';
import Axios from "axios";
import vuetify from "@/plugins/vuetify";
import alzuhudLink from "@/components/Functions/Functions";

@Component({
    components: {
        AdminPageInfo,
        AdminCard,
        btn,
        PackageCard
    }
})
export default class Dashboard extends Vue {
    // private panelTitle: string;
    @State adminUser: string;
    @State routes: string[];
    @Getter token: string;
    @Mutation popRoute: PopRoute;
    @Mutation replaceRoute: ReplaceRoute;
    @Mutation changePanelTitle: ChangePanelTitle;
    @Mutation setBookingId: setBookingId;
    @Mutation setTicketId: setTicketId;
    @Action snackIt: SnackIt;

    loadedCount: number = 0;
    mainLoading: boolean = false;
    headers = [
                {
                    text: 'Name',
                    align: 'left',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Code', value: 'packCode' },
                { text: 'Hotel', value: 'hotel' },
                { text: 'Flight', value: 'airline' },
                { text: 'Price', value: 'price' },
                { text: 'OP', value: 'action', sortable: false, align: 'right' }
                ];
    Packages = [];

        bookingsHeaders = [
                {
                    text: 'User',
                    align: 'left',
                    sortable: false,
                    value: 'user',
                },
                { text: 'Name', value: 'name' },
                { text: 'Package Code', value: 'code' },
                { text: 'Order Date', value: 'orderDate' },
                { text: 'Price', value: 'price' },
                { text: 'Passengers', value: 'passengers' },
                { text: 'OP', value: 'action', sortable: false, align: 'right'}
                ];
    bookingsRecord = [
                   ];

        ticketsHeaders = [
                { text: 'User', align: 'left', sortable: false,value: 'user' },
                { text: 'Subject', value: 'subject' },
                { text: 'Status', value: 'status' },
                { text: 'Date', value: 'date' },
                { text: 'OP', value: 'action', sortable: false, align: 'right' }
                ];
        tickets: any = [];

        transHeaders = [
                    {text: 'User', align: 'left', sortable: false, value: 'name'},
                    { text: 'Title', value: 'title' },
                    { text: 'Amount', value: 'amount' },
                    { text: 'Date', value: 'date' },
                    { text: 'Status', value: 'status', align: 'left' },
                    { text: 'OP', value: 'action', sortable: false, align: 'right' }
                ];
        transactions = [];

        agentsHeaders = [
                {text: 'Name', align: 'left', sortable: false, value: 'name'},
                { text: 'Last Activity', value: 'lastAct' },
                { text: 'OP', value: 'action', sortable: false, align: 'right' }
                ];
        agents: any = [];

        usersHeaders = [
                {text: 'Name', align: 'left', sortable: false, value: 'name'},
                { text: 'Last Activity', value: 'lastAct' },
                { text: 'OP', value: 'action', sortable: false, align: 'right' }
                ];
        users: any = [];

        dialog: boolean = false;

        rules = {
            // @ts-ignore
            required : value => !!value || 'Required',
            // @ts-ignore
            passMin: pass => {
            const passPattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
            return passPattern.test(pass) || 'At least 8 character and at least one letter and one number'
        },
        // @ts-ignore
        confirmedPass: cPass => cPass === this.editedUser.newPassword || 'Confirm password Not match',
        // @ts-ignore
        email: e => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(e) || 'Enter a valid e-mail address.'
        }
        };

        UserStatusList = [{text: 'Active', value: 1}, {text: 'Inactive', value: 2}, {text: 'Removed', value: 3}, {text: 'Banned', value: 4}];
        editedUser = {
            id: null,
            name: null,
            email: null,
            phone: null,
            newPassword: null,
            confirmNewPassword: null,
            status: null,
            role: '',
            token: this.token
        };
        saveLoading = false;


    editPackageDialog: boolean = false;
    dialogLoading = false;
    editedPackage = {
        id: null,
        name: null,
        type: null,
        airlineId: null,
        hotelId: null,
        originalPrice: null,
        status: null,
        packCode: null
    };
    hotelList = [];
    airlineList = [];
    packStatusList = [{text: 'Active', value: 1}, {text: 'Deactive', value: 0}, {text: 'Expired', value: 3}, {text: 'Banned', value: 2}, {text: 'Removed', value: 4}];

        agentsCount = null;
        ordersCount = null;
        packagesCount = null;
        ticketsCount = null;
        transactionsCount = null;
        usersCount = null;


    goToSupportPage (): void {
        this.$router.push("/admin/support")
    }
    goToAgentsPage (): void {
        this.$router.push("/admin/agents")
    }
    goToUsersPage (): void {
        this.$router.push("/admin/users")
    }
    goToPackagesPage (): void {
        this.$router.push("/admin/packages")
    }
    goToTransactionsPage (): void {
        this.$router.push("/admin/transactions")
    }
    // @ts-ignore
        getColor (status) {
            switch (status) {
                case "pending" :
                    return 'orange';
                case "not paid" :
                    return 'red';
                case "paid" :
                    return 'green';
                case "removed" :
                    return 'grey';
            }
        }

        viewBooking (id: number): void {
            // @ts-ignore
            this.setBookingId(id);
            this.$router.push('viewBooking');
        }

        async getDashboardData() {
            try {
                let response = await Axios.get(`http://${alzuhudLink}:8080/api/admin/dashboard`, {
                    params: {
                        token: this.token
                    }
                })
                let data = response.data.res;
                this.agentsCount = response.data.res.agents;
                this.ordersCount = response.data.res.orders;
                this.packagesCount = response.data.res.packages;
                this.ticketsCount = response.data.res.tickets;
                this.transactionsCount = response.data.res.transactions ;
                this.usersCount = response.data.res.users;

            } catch (e) {

            }
            this.loadedCount += 1;
        }
    // @ts-ignore
        async getAllBookings() {
        // this.tableLoading = true;
        try {
            let response = await Axios.get(`http://${alzuhudLink}:8080/api/booking/all`
                , {
                    params: {
                        token: this.token
                    }
                }).finally(/*() => this.tableLoading = false*/);
            let bookingsData = response.data.res.data;

            // @ts-ignore
            this.bookingsRecord = bookingsData.map(bok => ({
                id: bok.id,
                name: bok.name,
                user: typeof bok.user_id === "object" ? bok.user_id.full_name : 'Unknown',
                country: typeof bok.country_id === "object" ? bok.country_id.name : 'Unknown',
                orderNo: bok.id,
                // type: bok.type,
                price: '$' + this.split(bok.total_price),
                passengers: bok.num_adults + bok.num_childs,
                code: bok.package_id.code,
                orderDate: bok.created_at === null ? 'indeterminate' : new Date(bok.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                })
            }));
        } catch (e) {

            // this.tableLoading = false;
            this.snackIt({
                message: 'An error occurred: ' + e.response.data.message,
                color: 'error',
                snackbar: true
            });
        }
        this.loadedCount += 1;
    }

        async getAllPackages (): Promise<void> {
            try {
                let response = await Axios.get(`http://${alzuhudLink}:8080/api/packages/all`, {
                    params: {
                        token: this.token
                    }});
                let packagesData = response.data.res.data;
                // @ts-ignore
                this.Packages= packagesData.map( pgk => ({
                    id: pgk.id,
                    name: pgk.name,
                    packCode: pgk.code !== null ? pgk.code : 'Not Set!',
                    // type: typeof pgk.type === ,
                    hotel: pgk.hotel_id !== null ? pgk.hotel_id.en_name : 'Unknown',
                    airline: pgk.airline_id !== null ? pgk.airline_id.airline_id.name : 'Unknown',
                    airlineId: pgk.airline_id !== null ?  pgk.airline_id.id : 'Unknown',
                    hotelId:  pgk.hotel_id !== null ? pgk.hotel_id.id : 'Unknown',
                    price: '$' + this.split(pgk.price),
                    originalPrice: pgk.price,
                    status: pgk.status
                }));
            } catch (e) {
                console.log(e.response);
                this.snackIt({message: 'An error occurred while getting users data ', color: 'error', snackbar: true});
            }
            this.loadedCount += 1;
        }

        async getAllUsers (): Promise<void> {
            try {
                let response = await Axios.get(`http://${alzuhudLink}:8080/api/users/all`, {
                    params: {
                        token: this.token
                    }});
                let usersData = <User[]>response.data.res.data;
                let users = usersData.filter(obj => obj.role === 'user');
                this.users = users.map(user => ({
                    id: user.id,
                    name: user.full_name,
                    email: user.email,
                    status: user.status,
                    phone: user.phone,
                    role: user.role,
                    lastAct: new Date(user.updated_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    })
                }));

                let agents = usersData.filter(obj => obj.role === 'agent');
                this.agents = agents.map( agent => ({
                    id: agent.id,
                    name: agent.full_name,
                    email: agent.email,
                    status: agent.status,
                    phone: agent.phone,
                    role: agent.role,
                    lastAct: new Date(agent.updated_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    })
                }));



            } catch (e) {

            }
            this.loadedCount += 1;
        }

        //@ts-ignore
        edit (item) {
            // this.editedIndex = this.desserts.indexOf(item)
            this.editedUser = Object.assign(this.editedUser, item);
            //@ts-ignore
            switch (this.editedUser.status) {
                //@ts-ignore
                case 'active' :
                    //@ts-ignore
                    this.editedUser.status = 1;
                    break;
                //@ts-ignore
                case 'inactive' :
                    //@ts-ignore
                    this.editedUser.status = 2;
                    break;
                //@ts-ignore
                case 'removed' :
                    //@ts-ignore
                    this.editedUser.status = 3;
                    break;
                //@ts-ignore
                case 'banned' :
                    //@ts-ignore
                    this.editedUser.status = 4;
                    break;
            }

            this.dialog = true;
        }

        cancelEdit () {
            this.dialog = false;
        }

        async saveEdit (e: any) {
            e.preventDefault();
            this.saveLoading = true;
            let response = null;
            try {
                response = await Axios.post(`http://${alzuhudLink}:8080/api/users/update`, {
                    id: this.editedUser.id,
                    full_name: this.editedUser.name,
                    email: this.editedUser.email,
                    phone: this.editedUser.phone,
                    status: this.editedUser.status,
                    token: this.token
                })
                    .finally(() => {
                        this.saveLoading = false;
                    });
                this.getAllUsers();
                this.snackIt({message: 'Info updated successfully', color: 'success', snackbar: true});


            } catch (e) {
                this.saveLoading = false;
                this.snackIt({message: 'An error occurred! ' + e.response.data.error, color: 'error', snackbar: true});
            }
            if (this.editedUser.newPassword && this.editedUser.newPassword === this.editedUser.confirmNewPassword) {
                this.changePassword();
            }
        }

        async changePassword() {
            try {
                let resp = await Axios.post(`http://${alzuhudLink}:8080/api/admin/user/change-password`, {
                    id: this.editedUser.id,
                    password: this.editedUser.newPassword,
                    password_confirmation: this.editedUser.confirmNewPassword,
                    token: this.token,
                }).finally();

                this.snackIt({message: 'Password changed successfully', color: 'success', snackbar: true});
            } catch (e) {
                this.snackIt({message: 'An error occurred! ' + e.response.data.error, color: 'error', snackbar: true});
            }
        }

        async deleteUser(item: any): Promise<void> {
            if(confirm('Do you want to delete this user?')) {
                try {

                    let response = await Axios.get(`http://${alzuhudLink}:8080/api/users/delete/`+ item.id + '?token=' + this.token);
                    this.getAllUsers();

                    this.snackIt({message: 'Agent deleted successfully', color: 'success', snackbar: true});
                } catch (e) {

                    this.snackIt({message: 'An error occurred! ' + e.response.data.error, color: 'error', snackbar: true});
                }
            }
            else {

            }
        }
        async deleteAgent(item: any): Promise<void> {
            if(confirm('Do you want to delete this user?')) {
                try {
                    let response = await Axios.get(`http://${alzuhudLink}:8080/api/users/delete/`+ item.id + '?token=' + this.token);
                    this.getAllUsers();

                    this.snackIt({message: 'Agent deleted successfully', color: 'success', snackbar: true});
                } catch (e) {

                    this.snackIt({message: 'An error occurred! ' + e.response.data.error, color: 'error', snackbar: true});
                }
            }
            else {

            }
        }

        async getTickets (): Promise<void> {
            try {
                let response = await Axios.get(`http://${alzuhudLink}:8080/api/tickets/all`, {
                    params: {
                        token: this.token
                    }});
                let data = <Ticket[]>response.data.res.data;
                // this.items = data.filter(ticket => ticket.user_id.username === this.username).map(ticket => ({

                this.tickets = data.map(ticket => ({
                    id: ticket.id,
                    user: ticket.user_id.full_name,
                    subject: ticket.subject,
                    status: ticket.status,
                    date: new Date(ticket.created_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    })
                }));
            } catch (e) {
                console.error(e);
            }
            this.loadedCount += 1;
        }
    //@ts-ignore
    async getAllTransactions () {
        // his.tableLoading = true;

        try {
            let response = await Axios.get(`http://${alzuhudLink}:8080/api/transactions/all`, {params: {token: this.token}}
            ).finally(/*() => this.tableLoading = false*/);
            let items = response.data.res.data;

            //@ts-ignore
                this.transactions = items.map((item) => ({
                    name: item.user_id !== null ? item.user_id.full_name : 'Not Set!',
                    title: item.title,
                    amount: '$' + this.split(item.amount),
                    status: item.status,
                    bookingId: item.booking_id.id,
                    date: new Date(item.created_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    }),
                }));

        } catch (e) {
            console.log(e.response);
            // this.tableLoading = false;
            this.snackIt({
                message: 'An error occurred while getting users data ',
                color: 'error',
                snackbar: true
            });
        }
        this.loadedCount += 1;
    }

    //@ts-ignore
    split(str) {
        let strData = parseFloat(str);
        let data = strData.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return data.split('.')[0];
    }
    viewTicket (id: number) {
        console.log('id in support : ', id);
        this.setTicketId(id);
        this.$router.push('ticket');
    }
//@ts-ignore
    async editPackage (item) {
        try {
            //@ts-ignore
            this.editedPackage = [];
            this.editPackageDialog = true;
            this.dialogLoading = true;
            await this.getAllHotels();
            await this.getAllAirlines();
            this.editedPackage = Object.assign(this.editedPackage, item);
            // this.editedPackage.price = this.editedPackage.price.slice(1);
            //@ts-ignore
            switch (this.editedPackage.status) {
                //@ts-ignore
                case 'active' :
                    //@ts-ignore
                    this.editedPackage.status = 1;
                    break;
                //@ts-ignore
                case 'deactive' :
                    //@ts-ignore
                    this.editedPackage.status = 0;
                    break;
                //@ts-ignore
                case 'expired' :
                    //@ts-ignore
                    this.editedPackage.status = 2;
                    break;
                //@ts-ignore
                case 'banned' :
                    //@ts-ignore
                    this.editedPackage.status = 3;
                    break;
                //@ts-ignore
                case 'removed' :
                    //@ts-ignore
                    this.editedPackage.status = 4;
                    break;
            }
        } catch (e) {
            console.log(e);
        }
        finally {
            this.dialogLoading = false;
        }
    };
//@ts-ignore
    async deletePackage (id: number): void {
        if (confirm('Are you sure to close this package?')) {
            this.mainLoading = true;
            try {
                let response = await Axios.get(`http://${alzuhudLink}:8080/api/packages/delete/${id}`, {
                    params: {
                        token: this.token
                    }
                });
                this.snackIt({message: 'Package deleted', color: 'success', snackbar: true});
            } catch (e) {
                console.log(e.response);
                this.snackIt({
                    message: 'An error occurred while deleting package',
                    color: 'error',
                    snackbar: true
                });
            } finally {
                this.getAllPackages();
                this.mainLoading = false;
            }
        }
    };
//@ts-ignore
    async savePackagesEdit (e: any): void {
        e.preventDefault();
        this.saveLoading = true;
        try {
            await Axios.post(`http://${alzuhudLink}:8080/api/packages/update`, {
                id: this.editedPackage.id,
                airline_id: this.editedPackage.airlineId,
                hotel_id: this.editedPackage.hotelId,
                name: this.editedPackage.name,
                price: this.editedPackage.originalPrice,
                status: this.editedPackage.status,
                code: this.editedPackage.packCode,
                // start_date: this.newPackage.
                // end_date: this.newPackage.
                token: this.token,
                // id
                // airline_id
                // hotel_id
                // name
                // price
                // status
                // code
            });
            this.snackIt({message: 'Package updated', color: 'success', snackbar: true});
            this.getAllPackages();
            this.saveLoading = false;
        } catch (e) {
            this.saveLoading = false;
            console.log(e.response);
            this.snackIt({
                message: 'An error occurred while updating package',
                color: 'error',
                snackbar: true
            });
        }
        finally {
        }
    };
//@ts-ignore
    async getAllHotels () {
        try {
            let response = await Axios.get(`http://${alzuhudLink}:8080/api/hotels/all`, {
                params: {
                    type: 'all',
                    token: this.token
                }
            });
            //@ts-ignore
            this.hotelList = response.data.res.data.map(hotel => ({
                value: hotel.id,
                text: hotel.en_name
            }));
            // console.log(response);
        } catch (e) {
            console.log(e.response);
            this.snackIt({
                message: 'An error occurred while getting hotels data',
                color: 'error',
                snackbar: true
            });
        }
    };
//@ts-ignore
    async getAllAirlines () {
        try {
            let response = await Axios.get(`http://${alzuhudLink}:8080/api/airlines/all`, {
                params: {
                    type: 'all',
                    token: this.token
                }
            });
            //@ts-ignore
            this.airlineList = response.data.res.data.map(airline => ({
                value: airline.id,
                text: airline.name
            }));
            // console.log('air: ', response);
        } catch (e) {
            console.log(e.response);
            this.snackIt({
                message: 'An error occurred while getting airlines data',
                color: 'error',
                snackbar: true
            });
        }
    };

    isNumber(evt: Event | undefined) {
        evt = (evt) ? evt : window.event;
        // @ts-ignore
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            // @ts-ignore
            evt.preventDefault();
        } else {
            return true;
        }
    };


    @Watch('loadedCount')
    removeLoadingDisplay(newVal: number){
            if (newVal === 6) {
                this.mainLoading = false;
            }
    }

    mounted(): void {
        this.mainLoading = true;
        this.changePanelTitle('Dashboard');
        this.replaceRoute(['Dashboard']);
        this.$parent.$emit('update route');

        this.getAllUsers();
        this.getTickets();
        this.getAllTransactions();
        this.getAllBookings();
        this.getAllPackages();
        this.getDashboardData();

    }
    /**
     *
     */
    constructor() {
        super();
    }
    beforeDestroy(): void {
        this.popRoute();
        this.$parent.$emit('update route');
    }

    checkTicket(e: MouseEvent): void {
        alert('hello');
    }
}
